var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Transfer 组件
 * @author zhuwanying02, zhanghao14
 */

import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { isArray, isFunction, isEqual } from 'lodash-es';

import { classPrefix } from '../../common/util';

import TransferList from './TransferList';
import TransferOperation from './TransferOperation';

/**
 * 参数说明
 * dataSource         必选，数据源全集
 * targetIds          可选，显示在右边一栏数据的id集合
 * selectedIds        可选，设置数据里哪些项应该被选中
 * searchValue        可选，查询的内容
 * getValue           必选，选项在两栏之间转移时的回调函数
 * emptyLabel         可选，当列表为空时显示的内容
 * isShowSearch       可选，是否展示搜索框
 * classPrefix        可选，类名前缀
 * className          可选，根元素上添加类
 * style              可选，根元素上添加样式
 * transferListTitle  可选，左右两边列表的名称
 * width              可选，设置在左右两边列表的宽度
 * name               可选，在form中使用时必传，用于标识取值
 * onHandleChange     可选，忽略，form专用
 * formFlag           可选，忽略，form专用
 */

var Transfer = function (_Component) {
    _inherits(Transfer, _Component);

    function Transfer(props) {
        _classCallCheck(this, Transfer);

        var _this = _possibleConstructorReturn(this, (Transfer.__proto__ || Object.getPrototypeOf(Transfer)).call(this, props));

        _initialiseProps.call(_this);

        var dataSource = props.dataSource,
            selectedIds = props.selectedIds,
            targetIds = props.targetIds,
            searchValues = props.searchValues;


        _this.handleSelectedData = _this.handleSelectedData.bind(_this);
        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;

        _this.itemPos = _this.getItemPosition(dataSource);

        var transferData = _this.getTransferData(dataSource, selectedIds, targetIds);

        _this.state = _extends({}, transferData);

        _this.formCallback({ dataSource: dataSource, selectedIds: selectedIds, targetIds: targetIds, searchValues: searchValues }, _this.FORM_NO_NEED_VALIDATE);
        return _this;
    }

    _createClass(Transfer, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var dataSource = nextProps.dataSource,
                selectedIds = nextProps.selectedIds,
                targetIds = nextProps.targetIds,
                searchValues = nextProps.searchValues;


            if (!isEqual(dataSource, this.props.dataSource)) {
                this.itemPos = this.getItemPosition(dataSource);
            }

            if (!isEqual(dataSource, this.props.dataSource) || !isEqual(selectedIds, this.props.selectedIds) || !isEqual(targetIds, this.props.targetIds) || !isEqual(searchValues, this.props.searchValues)) {
                this.formCallback({ dataSource: dataSource, selectedIds: selectedIds, targetIds: targetIds, searchValues: searchValues }, this.FORM_NEED_VALIDATE);
            }
            this.setState(this.getTransferData(dataSource, selectedIds, targetIds));
        }
    }, {
        key: 'getItemPosition',
        value: function getItemPosition(dataSource) {
            var pos = {};
            dataSource.forEach(function (item, index) {
                return pos[item.id] = index;
            });
            return pos;
        }
    }, {
        key: 'formCallback',
        value: function formCallback(data) {
            var needValide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.FORM_NEED_VALIDATE;
            var _props = this.props,
                increment = _props.increment,
                name = _props.name,
                onHandleChange = _props.onHandleChange,
                formFlag = _props.formFlag;


            if (formFlag && onHandleChange && isFunction(onHandleChange)) {
                onHandleChange({
                    name: name,
                    value: data
                }, this, needValide, increment);
            }
        }
    }, {
        key: 'getTransferData',
        value: function getTransferData(dataSource, selectedIds, targetIds) {
            var _this2 = this;

            if (!dataSource || !isArray(dataSource)) {
                return;
            }
            var source = [];
            var target = [];
            var sourceSelectedIds = [];
            var targetSelectedIds = [];

            var pos = [];
            targetIds.forEach(function (id) {
                pos.push(_this2.itemPos[id]);
            });
            pos = pos.sort();
            // 两边数据始终按dataSource有序
            dataSource.forEach(function (item, index) {
                if (pos.indexOf(index) === -1) {
                    source.push(item);
                    if (selectedIds.indexOf(item.id) > -1 && !item.disabled) {
                        sourceSelectedIds.push(item.id);
                    }
                } else {
                    target.push(item);
                    if (selectedIds.indexOf(item.id) > -1 && !item.disabled) {
                        targetSelectedIds.push(item.id);
                    }
                }
            });
            return {
                source: source,
                target: target,
                sourceSelectedIds: sourceSelectedIds,
                targetSelectedIds: targetSelectedIds
            };
        }
    }, {
        key: 'getTransferListData',
        value: function getTransferListData(dataSource, newTargetIds) {
            var target = [];
            var source = [];
            newTargetIds.forEach(function (id) {
                target.push(dataSource.find(function (item) {
                    return item.id === id;
                }));
            });
            dataSource.forEach(function (item) {
                if (!newTargetIds.find(function (id) {
                    return id === item.id;
                })) {
                    source.push(item);
                }
            });
            return { source: source, target: target };
        }
    }, {
        key: 'handleSelectedData',
        value: function handleSelectedData(direction) {
            var _props2 = this.props,
                name = _props2.name,
                dataSource = _props2.dataSource,
                targetIds = _props2.targetIds,
                searchValues = _props2.searchValues,
                getValue = _props2.getValue;
            var _state = this.state,
                sourceSelectedIds = _state.sourceSelectedIds,
                targetSelectedIds = _state.targetSelectedIds;

            var newTargetIds = [];
            var newSelectedIds = [];
            if (direction === 'toTarget') {
                newTargetIds = [].concat(_toConsumableArray(sourceSelectedIds), _toConsumableArray(targetIds));
                newSelectedIds = [].concat(_toConsumableArray(targetSelectedIds));
            } else {
                // toSource
                newTargetIds = targetIds.filter(function (id) {
                    return targetSelectedIds.indexOf(id) === -1;
                });
                newSelectedIds = [].concat(_toConsumableArray(sourceSelectedIds));
            }

            var _getTransferListData = this.getTransferListData(dataSource, newTargetIds),
                target = _getTransferListData.target,
                source = _getTransferListData.source;

            if (getValue && isFunction(getValue)) {
                getValue({
                    name: name,
                    value: {
                        dataSource: dataSource,
                        source: source,
                        target: target,
                        searchValues: searchValues,
                        selectedIds: newSelectedIds,
                        targetIds: newTargetIds
                    }
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props3 = this.props,
                className = _props3.className,
                classPrefix = _props3.classPrefix,
                style = _props3.style,
                transferListTitle = _props3.transferListTitle,
                width = _props3.width,
                emptyLabel = _props3.emptyLabel,
                searchValues = _props3.searchValues,
                isShowSearch = _props3.isShowSearch;
            var _state2 = this.state,
                source = _state2.source,
                target = _state2.target,
                sourceSelectedIds = _state2.sourceSelectedIds,
                targetSelectedIds = _state2.targetSelectedIds;


            var prefixCls = classPrefix + '-transfer';
            var rootClass = classnames((_classnames = {}, _defineProperty(_classnames, '' + prefixCls, true), _defineProperty(_classnames, 'className', !!className), _classnames));
            var transferListTitleLeft = transferListTitle && transferListTitle[0];
            var transferListTitleRight = transferListTitle && transferListTitle[1];
            var widthLeft = width && width[0];
            var widthRight = width && width[1];
            var emptyLabelLeft = emptyLabel && emptyLabel[0];
            var emptyLabelRight = emptyLabel && emptyLabel[1];
            var searchValueLeft = searchValues && searchValues[0];
            var searchValueRight = searchValues && searchValues[1];
            return React.createElement(
                'div',
                { className: rootClass, style: style },
                React.createElement(TransferList, {
                    dataSource: source,
                    role: 'source',
                    isShowSearch: isShowSearch,
                    searchValue: searchValueLeft,
                    selectedIds: sourceSelectedIds,
                    title: transferListTitleLeft,
                    width: widthLeft,
                    emptyLabel: emptyLabelLeft,
                    onSelectChange: this.onSelectChange,
                    onSearchChange: this.onSearchChange
                }),
                React.createElement(TransferOperation, {
                    isLeftArrowClickable: targetSelectedIds.length > 0,
                    isRightArrowClickable: sourceSelectedIds.length > 0,
                    handleSelectedData: this.handleSelectedData
                }),
                React.createElement(TransferList, {
                    dataSource: target,
                    role: 'target',
                    isShowSearch: isShowSearch,
                    searchValue: searchValueRight,
                    selectedIds: targetSelectedIds,
                    title: transferListTitleRight,
                    width: widthRight,
                    emptyLabel: emptyLabelRight,
                    onSelectChange: this.onSelectChange,
                    onSearchChange: this.onSearchChange
                })
            );
        }
    }]);

    return Transfer;
}(Component);

Transfer.defaultProps = {
    classPrefix: classPrefix,
    selectedIds: [],
    targetIds: [],
    searchValues: ['', ''],
    isShowSearch: false,
    transferListTitle: ['列表1', '列表2'],
    emptyLabel: ['暂无内容', '暂无内容']
};
Transfer.propTypes = {
    classPrefix: PropTypes.string,
    dataSource: PropTypes.array,
    selectedIds: PropTypes.array,
    targetIds: PropTypes.array,
    searchValues: PropTypes.array,
    emptyLabel: PropTypes.array,
    isShowSearch: PropTypes.bool,
    searchProps: PropTypes.object,
    style: PropTypes.object,
    className: PropTypes.string,
    transferListTitle: PropTypes.array,
    width: PropTypes.array,
    onHandleChange: PropTypes.func,
    getValue: PropTypes.func,
    increment: PropTypes.string,
    name: PropTypes.string,
    formFlag: PropTypes.bool
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onSearchChange = function (_ref) {
        var role = _ref.role,
            value = _ref.value;
        var _props4 = _this3.props,
            dataSource = _props4.dataSource,
            name = _props4.name,
            selectedIds = _props4.selectedIds,
            targetIds = _props4.targetIds,
            getValue = _props4.getValue,
            searchValues = _props4.searchValues;
        var _state3 = _this3.state,
            source = _state3.source,
            target = _state3.target;

        var newsearchValues = [].concat(_toConsumableArray(searchValues));
        if (role === 'source') {
            newsearchValues[0] = value;
        } else {
            newsearchValues[1] = value;
        }
        if (getValue && isFunction(getValue)) {
            getValue({
                name: name,
                value: {
                    dataSource: dataSource,
                    selectedIds: selectedIds,
                    targetIds: targetIds,
                    searchValues: newsearchValues,
                    source: source,
                    target: target
                }
            });
        }
    };

    this.onSelectChange = function (_ref2) {
        var role = _ref2.role,
            newSelectedIds = _ref2.newSelectedIds;
        var _props5 = _this3.props,
            dataSource = _props5.dataSource,
            name = _props5.name,
            targetIds = _props5.targetIds,
            getValue = _props5.getValue,
            searchValues = _props5.searchValues;
        var _state4 = _this3.state,
            source = _state4.source,
            target = _state4.target,
            sourceSelectedIds = _state4.sourceSelectedIds,
            targetSelectedIds = _state4.targetSelectedIds;

        if (role === 'source') {
            newSelectedIds = [].concat(_toConsumableArray(newSelectedIds), _toConsumableArray(targetSelectedIds));
        } else {
            newSelectedIds = [].concat(_toConsumableArray(newSelectedIds), _toConsumableArray(sourceSelectedIds));
        }
        if (getValue && isFunction(getValue)) {
            getValue({ name: name, value: { dataSource: dataSource, selectedIds: newSelectedIds, targetIds: targetIds, searchValues: searchValues, source: source, target: target } });
        }
    };
};

export default Transfer;